import { Stack, Typography } from '@mui/material';
import { GRAPH_WIDTH } from './constants';
import { m } from 'framer-motion';

type LessonBubbleProps = {
  bottom: number;
  numLessons: number;
};

export const LessonBubble = ({ bottom, numLessons }: LessonBubbleProps) => (
  <m.div initial={{ scale: 0 }} animate={{ scale: 1 }}>
    <Stack
      alignItems="center"
      bgcolor="white"
      border="2px solid black"
      borderRadius="32px"
      bottom={bottom}
      boxShadow="2px 4px 4px 0px #0000001F"
      height="64px"
      justifyContent="center"
      left={GRAPH_WIDTH / 2}
      position="absolute"
      width="64px"
      sx={{ transform: 'translate(-50%, 50%)' }}
    >
      <Stack alignItems="center" height="53px">
        <Typography fontSize="20px" fontWeight={600} letterSpacing="0.46px" lineHeight="26px">
          {numLessons}
        </Typography>
        <Typography fontSize="12px" letterSpacing="0.46px" lineHeight="11px">
          Lessons
        </Typography>
      </Stack>
    </Stack>
  </m.div>
);
